<div>
  <div class="container-fluid">
    <div class="now-error-container">
      <div class="now-error-content">
        <h1 class="h2">Fehler 404 - Webseite nicht gefunden</h1>
        <p class="now-body-large">
          Hoppla, die angeforderte Webseite kann aktuell nicht gefunden werden. Alternativ finden
          Sie weitere Informationen auf unserer Startseite.
        </p>
        <a
          class="now-btn now-btn-primary now-btn-icon now-icon-arrow-right-after"
          [attr.href]="nowPortalBasePath"
        >
          Zur Startseite
        </a>
      </div>
      <img
        title="Fehler 404"
        class="img404"
        src="assets/images/error404.svg"
        alt="Die angeforderte Webseite kann aktuell nicht gefunden werden"
      />
    </div>
  </div>
</div>
